import { Link } from "react-router-dom";

/**
 * Global footer with legal links. Rendered on public pages (Login, Pricing,
 * public card landing) and any page where a footer is contextually useful.
 * Kept minimal so it does not compete with primary CTAs.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="app-footer"
      className="mt-16 border-t border-[var(--border-c)] bg-[var(--bg-1)]"
    >
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-wrap items-center justify-between gap-4 text-xs text-[var(--fg-3)] font-sans">
        <div>
          © {year} RecenUp · <span className="font-serif italic text-[var(--fg-2)]">One tap, More reviews</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/assistenza" data-testid="footer-help" className="hover:text-[#00F2F4]" style={{ transition: "color 0.2s ease" }}>
            Assistenza
          </Link>
          <Link to="/contatti" data-testid="footer-contact" className="hover:text-[#00F2F4]" style={{ transition: "color 0.2s ease" }}>
            Contatti
          </Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#00F2F4]" style={{ transition: "color 0.2s ease" }}>
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-[#00F2F4]" style={{ transition: "color 0.2s ease" }}>
            Termini di servizio
          </Link>
          <Link to="/condizioni-vendita" data-testid="footer-sales" className="hover:text-[#00F2F4]" style={{ transition: "color 0.2s ease" }}>
            Condizioni di vendita
          </Link>
        </nav>
      </div>
    </footer>
  );
}
